import { render } from "./SocialBox.vue?vue&type=template&id=464dd64d"
import script from "./SocialBox.vue?vue&type=script&lang=js"
export * from "./SocialBox.vue?vue&type=script&lang=js"

import exportComponent from "/Applications/MAMP/htdocs/adriengeoorge.github.io/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__